import React from "react";

import {MuiIcon, MuiIconExternalProps} from "./MuiIcon";

export const DuplicateIcon = (props: MuiIconExternalProps) => {
    return (
        <MuiIcon {...props}
        >{'\ue14d'}</MuiIcon>
    );
}
